var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.4 1.9a.9.9 0 0 1 .9-.9h5.4a.9.9 0 1 1 0 1.8H7.3a.9.9 0 0 1-.9-.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 4.6a.9.9 0 0 1 .9-.9h16.2a.9.9 0 1 1 0 1.8h-.958l-.578 8.663c-.045.68-.082 1.242-.15 1.7-.07.477-.18.913-.412 1.319a3.6 3.6 0 0 1-1.558 1.458c-.42.203-.863.285-1.343.323-.462.037-1.025.037-1.707.037H8.606c-.682 0-1.245 0-1.707-.037-.48-.038-.922-.12-1.343-.323a3.6 3.6 0 0 1-1.558-1.458c-.231-.406-.342-.842-.412-1.319-.068-.457-.105-1.02-.15-1.7L2.858 5.5H1.9a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};
export default SvgTrash;